import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { DialogFooter, InputField, wrapDialog } from "@teselagen/ui";
import { compose } from "recompose";
import { reduxForm } from "redux-form";
export const EditTrackNameDialog = compose(
  wrapDialog({
    title: "Edit Track Name"
  }),
  reduxForm({ form: "EditTrackNameDialog" })
)(function({ handleSubmit, updateName, hideModal }) {
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("div", { className: "bp3-dialog-body", children: /* @__PURE__ */ jsx(
      InputField,
      {
        autoFocus: true,
        label: "New Name",
        isRequired: true,
        name: "name"
      }
    ) }),
    /* @__PURE__ */ jsx(
      DialogFooter,
      {
        onClick: handleSubmit(async ({ name }) => {
          await updateName({ newName: name });
          hideModal();
        })
      }
    )
  ] });
});
